/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.betcrmcustomersummary.rpc.ActivityHistoryRpc
 */

export const getActivityHistoryByCrmCompanyIdRpc = {
  serviceName: 'com.hubspot.betcrmcustomersummary.rpc.ActivityHistoryRpc',
  rpcName: 'getActivityHistoryByCrmCompanyId',
  auth: 'app',
  fingerprint: 'VBwX1b5g0ozXJjUEXkMwJfLVuJ4bmHzT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActivityHistoryByDealIdRpc = {
  serviceName: 'com.hubspot.betcrmcustomersummary.rpc.ActivityHistoryRpc',
  rpcName: 'getActivityHistoryByDealId',
  auth: 'app',
  fingerprint: 'kH3HCfdTC7nXJjUEXkMwJfLVuJ4bmHzT',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};